import React, { PropTypes } from 'react'
import Heading from 'components/Heading'
import Card from 'components/Card'
import Loading from 'components/Loading'
import Alert from 'components/Alert'
import FileUploader from 'components/FileUploader/FileUploader'
import FineUploaderTraditional from 'fine-uploader-wrappers'
import SubmitButton from 'components/SubmitButton'
import constants from 'constants'
import TemplateUploadList from './components/TemplateUploadList'
import { agent } from 'utils/api'
// import moment from 'moment'
import { getConfig } from 'utils/config'
import { nextRun } from 'utils/nextRun'

const styles = Object.assign(
  {},
  require('./TemplateUpload.scss'),
  require('components/Table/Table.scss'),
  { columns: require('./columns.scss') },
)

class CapitalLoanAmtConfUploadView extends React.Component {
  static propTypes = {
    completeText: PropTypes.string,
    ctaText: PropTypes.string,
    delTemplate: PropTypes.object,
    initTemplates: PropTypes.object.isRequired,
    sendNotification: PropTypes.object.isRequired,
    submittingText: PropTypes.string,
    templateUpload: PropTypes.object.isRequired,
  }
  static defaultProps = {
    ctaText: 'Upload',
    completeText: 'Uploaded',
    submittingText: 'Uploading',
    delTemplate: null,
  }

  constructor() {
    super()

    this.state = {
      submittedFiles: [],
      uploader: null,
      isComplete: false,
      isPosting: false,
    }
  }

  componentWillMount() {
    this.setState({ uploader: this.myUploader() })
  }

  setSubmittedFiles = (submittedFiles) => {
    this.setState({ submittedFiles })
  }

  setFileUploaderResponse = () => {
  }

  handleDeleteTemplate = (itemId) => {
    this.props.delTemplate(itemId, getConfig().CAPITALLOAN_UPLOAD_LIBRARY, getConfig().CAPITALLOANAMTCONF_UPLOAD_FOLDER)
  }

  _initForm = () => {
    this.setState({ isPosting: false }, () => {
      this.setState({ uploader: this.myUploader() })
      this.setState({ isComplete: true })
      this.setState({ submittedFiles: [] })
      setTimeout(() => {
        this.props.initTemplates(getConfig().CAPITALLOAN_UPLOAD_LIBRARY, getConfig().CAPITALLOANAMTCONF_UPLOAD_FOLDER)
        this.setState({ isComplete: false })
      }, 2000)
    })
  }  

  _handleSubmit = () => {
    if (this.state.submittedFiles.length > 0) {
      this.setState({ isPosting: true }, () => {
        this.state.uploader.methods.uploadStoredFiles()
      })
    }
  }

  _handleAllUploadComplete = (id, name, response) => {
    if (response.success) {
      // this._initForm()
    } else {
      this.props.sendNotification(response.error)
    }
    this._initForm()
  }

  _handleUploadComplete = (id, name, response) => {
    if (response.success) {
      // this._initForm()
    } else {
      this.props.sendNotification(response.error)
    }
    this._initForm()
  }

  _handleUploadError = (id, name, response) => {
    this.props.sendNotification((response.error ? response.error : response))
  }

  // Moving logic from Uploader ...
  myUploader = () => {
    // const { allowedExtensions, uploadID, maxFileSize } = this.props
    const allowedExtensions = ['csv']
    // const uploadID = '1234'
    const maxFileSize = constants.PARTNERPLAN.MAX_FILESIZE
    const maxFileNumber = 1

    return new FineUploaderTraditional({
      options: {
        debug: true,
        autoUpload: false,
        request: {
          endpoint: agent.FileUploader.uploadtemplate(getConfig().CAPITALLOAN_UPLOAD_LIBRARY, getConfig().CAPITALLOANAMTCONF_UPLOAD_FOLDER),
        },
        cors: {
          expected: true,
          sendCredentials: true,
        },
        // deleteFile: {
        //   enabled: true,
        // },
        validation: {
          acceptFiles: allowedExtensions.map(e => `.${e}`),
          allowedExtensions,
          sizeLimit: maxFileSize,
          itemLimit: maxFileNumber,
        },
        chunking: {
          enabled: false,
          partSize: 5242880, // 5mb
          concurrent: {
            enabled: true,
          },
          success: {
          },
        },
        callbacks: {
          // onSubmit: this.uploaderSubmit,
          // onSubmitted: this.uploaderSubmitted,
          // onComplete: this._handleFormSubmit,
          onComplete: this._handleUploadComplete,
          onError: this._handleUploadError,
          // onStatusChange: this.uploaderStatusChange,
          // onProgress: this.uploaderProgress,
          // onUploadChunk: this.uploadChunk,
          // onUploadChunkSuccess: this.uploadChunkSuccess,
          // onUpload: this.startUpload,
          onAllComplete: this._handleAllUploadComplete,
          // onCancel: this.onCancel,
          // onDelete: this.onDelete,
        },
      },
    })
  }

  canSubmit = () => {
    return (this.state.submittedFiles.length > 0)
  }

  render() {
    const {
      ctaText,
      completeText,
      submittingText,
      templateUpload,
    } = this.props
    // eslint-disable-next-line dot-notation
    // const form = this.props.forms['PartnerPlanRatingsUpload']
    if (templateUpload.isFetching) {
      return (<Loading pageLoading />)
    }

    const inProgress = templateUpload.templateUploaded.filter(ppr => String(ppr.status) === constants.TEMPLATE.UPLOAD.INPROGRESS)
    return (
      <div className={styles.content}>
        <section className={styles.section}>
          {templateUpload.fetched && templateUpload.templateUploaded &&
          <div>
            <TemplateUploadList
              deleteTemplate={this.handleDeleteTemplate}
              header={`${constants.TEMPLATE.UPLOAD.PENDING} to be processed. (next run is at ${nextRun(getConfig().PLAN_RATINGS_RUNINTERVAL_HOUR)})`}
              templateUploadItems={templateUpload.templateUploaded.filter(ppr => String(ppr.status) === constants.TEMPLATE.UPLOAD.PENDING)}
            />
            {inProgress && inProgress.length > 0 &&
              <TemplateUploadList
                header={constants.TEMPLATE.UPLOAD.INPROGRESS}
                templateUploadItems={templateUpload.templateUploaded.filter(ppr => String(ppr.status) === constants.TEMPLATE.UPLOAD.INPROGRESS)}
              />
            }
            <TemplateUploadList
              header={constants.TEMPLATE.UPLOAD.COMPLETED}
              templateUploadItems={templateUpload.templateUploaded.filter(ppr => String(ppr.status) === constants.TEMPLATE.UPLOAD.COMPLETED || String(ppr.status) === constants.TEMPLATE.UPLOAD.COMPLETEDWITHERRORS || String(ppr.status) === constants.TEMPLATE.UPLOAD.INVALIDUPLOAD)}
            />
            <TemplateUploadList
              header={`Download ${constants.TEMPLATE.UPLOAD.TEMPLATE}`}
              templateUploadItems={templateUpload.templateUploaded.filter(ppr => String(ppr.status) === constants.TEMPLATE.UPLOAD.TEMPLATE)}
            />
          </div>}
          <div>
            <Heading noTopPadding>Upload capital loan amount confirmation</Heading>
            <Card>
              <div className={styles.uploadSection}>
                <Alert showCloseButton={false} type="error">
                  {`Make sure to copy the PDF documents to be signed to '${constants.TEMPLATE.ANNUALCONFIRMATION_PATH}' 30 minutes before uploading the csv file.`}<br /><br />
                  Please note that upload of file will auto create and SEND documents to all listed recipients at the next displayed run time.
                </Alert>
                <Alert type="info">
                Ensure filenames are unique and not used on previous upload and only use numbers, letters and underscores.
                </Alert>
                <FileUploader
                  allowedExtensions={['csv']}
                  handleDeleteExistingFile={file => console.log('### delete', file)}
                  handleSelectedFile={() => console.log('### selected ###')} // 1 MB = 1000 * 1000 * 1024 bytes
                  labelWidth={20}
                  maxFileSize={constants.PARTNERPLAN.MAX_FILESIZE}
                  multiple={false}
                  setFileUploaderResponse={this.setFileUploaderResponse}
                  setSubmittedFiles={this.setSubmittedFiles}
                  uploadDescText="CSV only, max 20mb."
                  // disabled={fileUploaderDisabled}
                  uploadTitle="Add files here"
                  uploader={this.state.uploader}
                />
                <div className={styles.footer}>
                  <SubmitButton
                    isLarge
                    complete={this.state.isComplete}
                    completeText={completeText} // Add validation rules
                    disabled={!this.canSubmit()}
                    onClick={() => this._handleSubmit()}
                    submitting={this.state.isPosting}
                    submittingText={submittingText}
                  >
                    {ctaText}
                  </SubmitButton>
                </div>
              </div>
            </Card>
          </div>
        </section>
      </div>
    )
  }
}

export default CapitalLoanAmtConfUploadView



// WEBPACK FOOTER //
// ./src/views/TemplateUpload/CapitalLoanAmtConfUpload.js